module.exports = __webpack_public_path__ + "static/media/safari-pinned-tab.94a16262.svg";